export default "__VITE_ASSET__CCPZR2WF__"